import { type ReactNode } from 'react';
import { Button, type MenuItemCommandEvent } from '@ics-portal/guardian';
import type { GridApi } from '@ag-grid-community/core';
import type { ICSAgGridProps } from '../ICSAgGrid';
import {
    useICSGridActionsContext,
    useRegisterMasterGrid,
} from './ICSGridActionsContext';

type ICSGridActionsProps<TData> = Partial<ICSAgGridProps<TData>> & {
    api?: GridApi<TData>;
};

export function ICSGridActions<TData>({
    api,
    context,
    contextMenuItems,
    detailCellRendererParams,
}: ICSGridActionsProps<TData>): ReactNode {
    useRegisterMasterGrid(
        api,
        context,
        contextMenuItems,
        detailCellRendererParams,
    );

    const items = useICSGridActionsContext();

    return items.map((item) => (
        <Button
            key={item.label}
            severity="secondary"
            icon={item.icon as string | undefined}
            onClick={() => {
                item.command?.({
                    originalEvent: undefined,
                    item,
                } as unknown as MenuItemCommandEvent);
            }}
        >
            {item.label}
        </Button>
    ));
}
